import React from 'react'
import OnVisible from 'react-on-visible'
import { Image } from 'newComponents'
import './styles.scss'

// image import
import triggersGreen from '../../../images/icons/trigger-green.svg'
import schedulesGreen from '../../../images/icons/schedules-green.svg'
import toggleGreen from '../../../images/icons/toggle-green.svg'
import toggleOffGreen from '../../../images/icons/toggle-off-green.svg'
import deploy from '../../../images/icons/deploy-circles.svg'
import speedo from '../../../images/icons/speedo-green.svg'
import lockGreen from '../../../images/icons/lock-green.svg'
import plus from '../../../images/icons/plus.svg'
import plusDark from '../../../images/icons/plus-dark.svg'
import arrow from '../../../images/icons/right-arrow.svg'

// ordered objects

const tabOptions = {
  Build: [
    { icon: toggleOffGreen, key: 'toggleOffGreen1', text: 'Feature Flag Off' },
    { icon: deploy, key: 'deploy1', text: 'Deploy to Internal Team' },
    { icon: schedulesGreen, key: 'schedulesGreen1', text: 'Wait 3 Days' },
    { icon: deploy, key: 'deploy2', text: 'Deploy to “Beta” Segment' },
    { icon: schedulesGreen, key: 'schedulesGreen2', text: 'Wait 5 Days' },
    { icon: deploy, key: 'deploy3', text: 'Incremental Rollout Over 3 Days' },
    { icon: toggleGreen, key: 'toggleGreen1', text: 'Deploy to 100%' }
  ],

  Operate: [
    { icon: toggleGreen, key: 'toggleGreen2', text: 'Feature Flag On' },
    { icon: speedo, key: 'speedo1', text: 'CPU > 95%' },
    { icon: triggersGreen, key: 'triggersGreen1', text: 'Flag Trigger' },
    { icon: toggleOffGreen, key: 'toggleOffGreen2', text: 'Feature Flag Off' }
  ],

  Learn: [
    { icon: toggleOffGreen, key: 'toggleOffGreen3', text: 'Feature Flag Off' },
    { icon: deploy, key: 'deploy4', text: 'Deploy A/B Test to Segment “Beta”' },
    { icon: schedulesGreen, key: 'schedulesGreen3', text: 'Wait 20 Days' },
    { icon: triggersGreen, key: 'triggersGreen2', text: 'Flag Trigger for Winning Variation' },
    { icon: deploy, key: 'deploy5', text: 'Select Winning Variation' },
    { icon: toggleGreen, key: 'toggleGreen3', text: 'Deploy Winning Variation to 100%' }
  ],

  Empower: [
    { icon: toggleGreen, key: 'toggleGreen4', text: 'Feature Flag ON' },
    { icon: deploy, key: 'deploy6', text: 'Add Customer to Segment “Trial”' },
    { icon: schedulesGreen, key: 'schedulesGreen4', text: 'Add Expiration of 30 Days' },
    { icon: lockGreen, key: 'lockGreen1', text: 'Manager Approval' },
    { icon: deploy, key: 'deploy7', text: 'Customer Added to Trial' },
    { icon: schedulesGreen, key: 'schedulesGreen5', text: 'Customer Removed After 30 Days' }
  ]
}

const TabIconCollection = ({ icons, textContent }) => {
  if (!icons) return null
  const tabOptionKeys = Object.keys(tabOptions)

  return (
    <OnVisible className="tab-icon-collection">
      {tabOptionKeys.map((tabOptionKey, index) => {
        const tabOptionTitle = tabOptionKey
        const tabOptionIcons = tabOptions[tabOptionKey]
        const isActive = tabOptionKey === icons
        // if (workflowVariant === 'normal-variant' && tabOptionTitle === 'Workflow Templates') return null

        return (
          <div className={`tab-icon-collection-section ${isActive ? 'active' : 'not-active'} `} key={tabOptionTitle}>
            {/* TITLE AND SUB title */}
            <span className="tab-icon-collection-section-title">{tabOptionTitle}</span>
            {textContent &&
              textContent.map((item) => {
                const { tab_content: content, tab_title: title } = item
                const activeContent =
                  title.text === tabOptionTitle ? (
                    <span className="tab-icon-collection-section-subtitle" key={content.text}>
                      {content.text}
                    </span>
                  ) : null
                return activeContent
              })}
            {/* ICONS */}
            {tabOptionIcons.map((tabOptionIcon, i) => {
              const betweenIcon = i < tabOptionIcons.length - 2 ? plus : arrow
              const seperator = icons === 'Workflow Templates' ? betweenIcon : plusDark
              const firstLast = i === 0 || i === tabOptionIcons.length - 1 ? 'first-last' : ''
              const { icon, key, text } = tabOptionIcon
              return (
                <div className={`tab-icon-collection-container ${firstLast}`} key={key}>
                  <div className="tab-icon-collection-icon-group">
                    <Image className="tab-icon-collection-icon" image={{ url: icon }} />
                    {i < tabOptionIcons.length - 1 && (
                      <Image className="tab-icon-collection-plus-icon" image={seperator} />
                    )}
                  </div>
                  <span className="tab-icon-collection-icon-text">{text}</span>
                </div>
              )
            })}
          </div>
        )
      })}
    </OnVisible>
  )
}
export default TabIconCollection
